import { render, staticRenderFns } from "./ReservationsAdmin.vue?vue&type=template&id=f7640a62&"
import script from "./ReservationsAdmin.vue?vue&type=script&lang=js&"
export * from "./ReservationsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports